<template>
	<ProcessCreatePage>
		<Header :title="$t('new_damage_case_opponent').toString()">
			<p>
				{{ $t('required_data_red_stars') }}
			</p>
		</Header>

		<div class="main">
			<OppositePersonForm ref="accident-data-form" @input="updateValue" :show-opposite-case-number="true" :show-opposite-insurance="true" />
		</div>

		<Footer @backButtonClick="$emit('previous', $event)" @continueButtonClick="continueButtonClick($event)" :is-skippable="false" />
	</ProcessCreatePage>
</template>

<script>
import Header from '@/components/damagecases/Header';
import Footer from '@/components/damagecases/Footer';
import OppositePersonForm from '@/components/damagecases/forms/OppositePersonForm';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
export default {
	name: 'OppositePerson',
	components: { ProcessCreatePage, OppositePersonForm, Footer, Header },
	data() {
		return {
			accidentData: {},
		};
	},
	methods: {
		updateValue: function($event) {
			this.accidentData = $event;
		},
		continueButtonClick: function($event) {
			if (this.$refs['accident-data-form'].validate()) {
				this.$emit('next', this.accidentData);
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
